import { JSX } from "react";

/** API может возвращать created_at, updated_at в формате ISO 8601 */
type TDocument = any;

type TDocItem = any;

type TDocumentToDraw = any;

type TDocItemToDraw = any;

type TDocumentsOperation = {
  id: string;
  name: string;
  include?: boolean;
};

type TDocumentModalData = {
  name: string;
  type: EDocumentsModalDataType;
  field?: string;
};

type TDocumentMainColumn = {
  headerName: string;
  field: string;
  width?: number;
};

type TDocumentsFilters = {
  shouldUpdate?: boolean;
  shouldReplace?: boolean;
  page?: number;
  pageSize?: number;

  dateFrom?: Date;
  dateTo?: Date;

  type?: number;
  search?: string;
  storeid?: number;
  store2id?: number;
};

type TDocItemsFilters = {
  docid?: string;
  page?: number;
  pageSize?: number;
};

type TOpenedDocumentState = {
  docid?: string;
  time?: Date;
  comment?: string;
  storeid?: number;
  store2id?: number;
  priceupdated?: boolean;
};

type TOpenedDocItemState = {
  docitemid?: string;
  docid?: string;
  itemid?: string;
  item2id?: string;
  measureid?: string;
  measure2id?: string;
  realamount?: string;
  amount?: string;
  difference?: string;
  price?: string;
  total?: string;
  pricelistid?: string;
  frontprice?: string;
  salepercent?: string;
  itemcomment?: string;
};

export enum EDocumentsMainFilters {
  "dateFrom",
  "dateTo",
  "search",
  "store",
  "store2",
}

export enum EDocumentsModalDataType {
  "textPointer",
  "store",
  "store2",
  "date",
  "time",
  "priceupdated",
  "comment",
}

type TDocumentsData = {
  [key: string]: {
    mainFilters?: EDocumentsMainFilters[];
    mainColumns?: TDocumentMainColumn[];
    modalData?: TDocumentModalData[];
    modalColumns?: TDocumentMainColumn[];
    bottomRow?: ({
      documentsToDraw,
    }: {
      documentsToDraw: TDocumentToDraw[];
    }) => TDocumentToDraw;
    modalBottomRow?: ({
      filteredDocItems,
    }: {
      filteredDocItems: TDocItemToDraw[];
    }) => TDocItemToDraw;
    modalModalComponent?: JSX.Element;
    shouldCheck2Stores?: boolean;
  };
};

type TDocBottomRows = {
  [key: string]: ({
    documentsToDraw,
  }: {
    documentsToDraw: TDocumentToDraw[];
  }) => TDocumentToDraw;
};

type TDocItemsBottomRows = {
  [key: string]: ({
    filteredDocItems,
  }: {
    filteredDocItems: TDocItemToDraw[];
  }) => TDocItemToDraw;
};

export type {
  TDocumentsOperation,
  TDocumentsData,
  TDocumentsFilters,
  TDocument,
  TDocumentToDraw,
  TDocumentMainColumn,
  TDocumentModalData,
  TOpenedDocumentState,
  TDocItem,
  TDocItemToDraw,
  TOpenedDocItemState,
  TDocItemsFilters,
  TDocItemsBottomRows,
  TDocBottomRows,
};
